import { Box, styled } from '@mui/system'
import { useNavigate } from 'react-router-dom'
import keycloak from '../../keycloak'
import { useContext } from 'react'
import { AuthContext } from '@contexts/Auth'
import ProfileMenu from '@components/map/ProfileMenu'
import UserService from '@services/users/user.service'

type NavBarProps = {
	hideSideBar?: boolean
}
export default function NavBar({hideSideBar}: NavBarProps) {
	const { state, dispatch } = useContext(AuthContext)
	const navigate = useNavigate()
	const NavBarBox = styled(Box)(() => ({
		width: '100%',
		height: '80px',
		backgroundColor: '#020f1d',
		zIndex: '999',
		display: 'flex',
		justifyContent: 'flex-end',
	}))

	const NavBarRightBox = styled(Box)(() => ({
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'center',
		alignContent: 'center',
		padding: '30px',
	}))

	return (
		<NavBarBox>
			<div className="logo-wrapper"
			{...(!hideSideBar ? 
				{
					role:"button",
					onClick: () => navigate('/configurations/users_config')
				}: {} )}
			 >
				<img src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0MS43NjEiIGhlaWdodD0iNDIuOTM3IiB2aWV3Qm94PSIwIDAgNDEuNzYxIDQyLjkzNyI+DQogIDxnIGlkPSLnu4RfNTIxMSIgZGF0YS1uYW1lPSLnu4QgNTIxMSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTc0MyAyMjApIj4NCiAgICA8cGF0aCBpZD0i6Lev5b6EXzE5MjY4IiBkYXRhLW5hbWU9Iui3r+W+hCAxOTI2OCIgZD0iTTExLjg1LDBWMTMuOTI3aC0uMDA4djIuOUgyNC42MDh2LTIuOUgxOC4yMzNWMFoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDczOC42OTMgLTIyMCkiIGZpbGw9IiNmZmYiLz4NCiAgICA8cGF0aCBpZD0i6Lev5b6EXzE5MjY5IiBkYXRhLW5hbWU9Iui3r+W+hCAxOTI2OSIgZD0iTTAsMFYyMC44OUg2LjM4M3YwSDIwLjN2LTIuOUg2LjM4M1YwWiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNzQzIC0yMjApIiBmaWxsPSIjZmZmIi8+DQogICAgPHBhdGggaWQ9Iui3r+W+hF8xOTI3MCIgZGF0YS1uYW1lPSLot6/lvoQgMTkyNzAiIGQ9Ik0xMS44NSw0MS4wMzVoLS4wMDh2Mi45aC4wMDhWNTcuODYzaDYuMzgzVjQzLjkzN2g2LjM3NXYtMi45SDExLjg1WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNzM4LjY5MyAtMjM0LjkyNikiIGZpbGw9IiNmZmYiLz4NCiAgICA8cGF0aCBpZD0i6Lev5b6EXzE5MjcxIiBkYXRhLW5hbWU9Iui3r+W+hCAxOTI3MSIgZD0iTTAsMzQuNjUxdjIwLjg5SDYuMzgzVjM3LjU1NUgyMC4zdi0yLjlINi4zODN2MFoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDc0MyAtMjMyLjYwNCkiIGZpbGw9IiNmZmYiLz4NCiAgICA8cGF0aCBpZD0i6Lev5b6EXzE5MjcyIiBkYXRhLW5hbWU9Iui3r+W+hCAxOTI3MiIgZD0iTTQwLjEsMFYxMy45MjdIMzMuNzI4djIuOUg0Ni40OTV2LTIuOWgtLjAwOVYwWiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNzMwLjczMiAtMjIwKSIgZmlsbD0iI2ZmZiIvPg0KICAgIDxwYXRoIGlkPSLot6/lvoRfMTkyNzMiIGRhdGEtbmFtZT0i6Lev5b6EIDE5MjczIiBkPSJNNDcuNjQ2LDBWMTcuOTg2SDMzLjcyOHYyLjlINDcuNjQ2djBoNi4zODJWMFoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDczMC43MzIgLTIyMCkiIGZpbGw9IiNmZmYiLz4NCiAgICA8cGF0aCBpZD0i6Lev5b6EXzE5Mjc0IiBkYXRhLW5hbWU9Iui3r+W+hCAxOTI3NCIgZD0iTTQwLjEsNDEuMDM1SDMzLjcyOXYyLjlINDAuMVY1Ny44NjNoNi4zODNWNDMuOTM3aC4wMDh2LTIuOUg0MC4xWiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNzMwLjczMiAtMjM0LjkyNikiIGZpbGw9IiNmZmYiLz4NCiAgICA8cGF0aCBpZD0i6Lev5b6EXzE5Mjc1IiBkYXRhLW5hbWU9Iui3r+W+hCAxOTI3NSIgZD0iTTQ3LjY0NiwzNC42NTNIMzMuNzI5djIuOUg0Ny42NDZWNTUuNTQxaDYuMzgzVjM0LjY1MUg0Ny42NDZaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg3MzAuNzMyIC0yMzIuNjA0KSIgZmlsbD0iI2ZmZiIvPg0KICA8L2c+DQo8L3N2Zz4NCg==" />
			</div>
			<NavBarRightBox>
				<ProfileMenu
					handleLogout={() => {
						navigate('/')
						console.log('Logout AuthContext', state.userInfo)
						localStorage.clear()
						// UserService.CreateAuditTrail({
						// 	date: new Date().toISOString(),
						// 	message: 'Logout system',
						// 	eventType: 'LOGOUT',
						// 	status: 'SUCCESS',
						// }).finally(()=>{
						// })
						keycloak.logout({ redirectUri: window.location.origin })
						dispatch({ type: 'logout' })
					}}
				/>
			</NavBarRightBox>
		</NavBarBox>
	)
}
